import ButtonComponent from '../../../Buttons/ButtonComponent';

import Styles from '../styles.module.scss';
import pic from '../../../../assets/brokers/top_pic.svg';

const BrokersTopSection = (props) => (
  <div className={Styles['top-section-brokers']}>
    <div className={Styles['section']}>
      <div className={Styles['flex-wrapper']}>
        <div className={Styles['text-section']}>
          <h1>Increase Your Revenue</h1>
          <h3>
            Acquire More Customers
            <br />
            Inform and Engage Them
          </h3>
          <p>
            Solutions for Brokers, Advisors, and Wealth Managers
          </p>
          <div className={Styles['buttons-section']}>
            <ButtonComponent
              clickHandler={(e) => { e.preventDefault(); props.goToContactForm(); }}
              value="Contact Us"
              green
              path=""
            />
          </div>
        </div>
        <div className={Styles['image-section']}>
          <img src={pic} alt="" />
        </div>
      </div>
    </div>
  </div>
);

export default BrokersTopSection;
